module.exports = __webpack_public_path__ + "static/img/scene8.e80b979f.png";